import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { useAuth } from 'model/Auth';
import { useApi } from 'model/Api';
import { User } from 'model/User';
import { hasPermission } from 'model/Route';
import { generalStyle } from 'helper/Style';
import { convertUserName } from 'helper/Converter';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import ConfirmResultModal from 'component/part/ConfirmResultModal';
import H2 from 'component/part/H2';

const MemberShow: React.FC = () => {
  const api = useApi();
  const { user: owner } = useAuth();
  const enableEdit = owner && hasPermission('member', 'edit', owner.role);
  const displaySensitive = !!owner?.role?.permissions.userEdit;
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const userId = parseInt(urlParams.id || '');
  const [user, setUser] = useState<User>();
  const [confirm, setConfirm] = useState(false);
  const [email, accountName] = user?.role?.permissions.login
    ? [user?.email, user?.accountName]
    : [null, null];

  const onSubmit = async () => {
    if (!user) return false;
    const result = await api.user.delete(user.id);

    return result.ok && !!result.data?.result;
  };

  useEffect(() => {
    (async () => {
      if (userId) {
        const userResponse = await api.user.get(userId, { with: ['role'] });
        if (userResponse) {
          setUser(userResponse);
        }
      }
    })();
  }, [userId]);

  return <Layout>
    <BackLink link='/member/list' label='メンバー一覧'></BackLink>
    <H2>メンバー情報</H2>
    <div css={generalStyle.form}>
      <FormContent label='氏名'>
        <div css={generalStyle.item()}>{user ? convertUserName(user) : ''}</div>
      </FormContent>
      <FormContent label='役職'>
        <div css={generalStyle.item()}>{user?.role?.name || ''}</div>
      </FormContent>
      {displaySensitive && (
        <Fragment>
          <FormContent label='ユーザー名'>
            <div css={generalStyle.item()}>{accountName || 'ー'}</div>
          </FormContent>
          <FormContent label='メールアドレス'>
            <div css={generalStyle.item()}>{email || 'ー'}</div>
          </FormContent>
          <FormContent label='日給'>
            <div css={generalStyle.item()}>{user?.salary ? `\xA5${user.salary.toLocaleString()}` : 'ー'}</div>
          </FormContent>
        </Fragment>
      )}
      {user && enableEdit && (
        <div css={generalStyle.formRow}>
          <NavLink to={`/member/${user.id}/edit`} css={generalStyle.button()}>編集</NavLink>
          <button onClick={() => setConfirm(true)} css={generalStyle.button('warning')}>削除</button>
        </div>
      )}
    </div>
    <ConfirmResultModal
      display={confirm}
      onHide={() => setConfirm(false)}
      onSubmit={onSubmit}
      onOk={() => navigate('/member/list')}
      objectType='member'
      operationType='delete'
    />
  </Layout>;
};

export default MemberShow;
